// src/pages/BlogScreen.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useApp } from '../lib/AppContext';

export default function BlogScreen() {
  const { lang } = useApp();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.from('blog_posts').select('id,slug,title,excerpt,category,cover_image,read_time_minutes,created_at')
      .eq('published', true).order('created_at', { ascending: false })
      .then(({ data }) => { setPosts(data || []); setLoading(false); });
  }, []);

  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh' }}><div className="spinner" /></div>;

  return (
    <div className="page-container" style={{ padding:'40px 24px' }}>
      <h1 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'2.5rem', letterSpacing:'.05em', marginBottom:8 }}>Blog</h1>
      <p style={{ color:'#666', fontSize:'.9rem', fontWeight:300, marginBottom:32 }}>Education, collector guides and EU legal updates</p>

      {posts.length === 0 ? (
        <div style={{ textAlign:'center', padding:'4rem 0', color:'#555' }}>
          <div style={{ fontSize:'3rem', opacity:.15, marginBottom:12 }}>📝</div>
          <p style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.9rem', letterSpacing:'.1em', textTransform:'uppercase' }}>No posts yet</p>
        </div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:24 }}>
          {posts.map(post => (
            <div key={post.id} onClick={() => navigate(`/blog/${post.slug}`)} style={{ background:'#111', borderRadius:16, border:'1px solid rgba(255,255,255,.07)', overflow:'hidden', cursor:'pointer', transition:'transform .2s, border-color .2s' }}
              onMouseOver={e => { e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.borderColor='rgba(76,202,116,.2)'; }}
              onMouseOut={e  => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.borderColor='rgba(255,255,255,.07)'; }}
            >
              {post.cover_image && <img src={post.cover_image} alt="" style={{ width:'100%', height:180, objectFit:'cover' }} />}
              <div style={{ padding:20 }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.68rem', fontWeight:700, letterSpacing:'.18em', textTransform:'uppercase', color:'#4cca74', marginBottom:8 }}>{post.category}</div>
                <h3 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'1.15rem', fontWeight:700, color:'#f4f4f4', marginBottom:8, lineHeight:1.25 }}>{post.title?.[lang] || post.title?.en}</h3>
                <p style={{ fontSize:'.84rem', color:'#666', fontWeight:300, lineHeight:1.7, marginBottom:12, display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}>
                  {post.excerpt?.[lang] || post.excerpt?.en}
                </p>
                <div style={{ display:'flex', gap:8, fontSize:'.73rem', color:'#444' }}>
                  <span>{new Date(post.created_at).toLocaleDateString()}</span>
                  <span>·</span>
                  <span>{post.read_time_minutes} min read</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
